import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FocusSidebarComponent } from '../focus-sidebar/focus-sidebar.component';

@Component({
  selector: 'inexp-focus-dashboard',
  imports: [FocusSidebarComponent, RouterModule],
  templateUrl: './focus-dashboard.component.html',
  styleUrl: './focus-dashboard.component.scss',
})
export class FocusDashboardComponent {}
